import React, { useContext, useEffect, useState } from 'react';
import {
	Container,
	Row,
	Col,
	Table,
} from 'reactstrap';
import Pagination from 'react-js-pagination';
import history from '~/services/history';
import { NotificacaoContext } from '~/context/NotificacaoContext';
import ReactGA from 'react-ga4';

import { FiltroBar } from '~/components/Filtros/FiltroBar';
import { LoaderLista } from '~/components/Loaders';
import { SubHeader } from '~/components/SubHeader';

import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';

import { color } from '~/assets/styles/colors';
import { TrStyled, ButtonStyled } from './styles';


export default function HistoricoNotificacao() {
	const { getNotificacoes, lerNotificacao, lerTodasNotificacoes } = useContext(NotificacaoContext);
	const [notificacoes, setNotificacoes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [pagina, setPagina] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	const [abreTabela,] = useState(true);
	const [isMobile, setIsMobile] = useState(false);

	function handlerPagination(page) {
		setPagina(page);
	}

	function handleClickNotificacaoGA4() {
		ReactGA.event({
			category: "view_notificacao",
			action: "Visualizou Notificação",
			label: "Visualizando Notificação",
		});
	}

	const handleRequestNotification = (data) => {
		lerNotificacao(data.id);
		handleClickNotificacaoGA4();
		history.push({
			pathname: `/client/transacoes`,
			state: data,
		});
	};

	const handleLerTodas = () => {
		lerTodasNotificacoes().then(() =>
			getNotificacoes('all=true', pagina).then(res => {
				setNotificacoes(res.data.notifications)
			}));
	};

	useEffect(() => {
		setLoading(true);
		getNotificacoes('all=true', pagina).then(res => {
			setTotalItems(res.data.total_notifications)
			setNotificacoes(res.data.notifications);
		}).then(() => setLoading(false))
	}, [pagina])

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Notificações',
						link: '/client/notificacoes',
					},
				]}
			/>
			<FiltroBar />
			<Row>
				<Col className={abreTabela ? 'd-block' : 'd-none'}>
					<LoaderLista
						lista={notificacoes}
						loading={loading}
						error={notificacoes.error}>
						<ButtonStyled
							className="novoPedido"
							type="button"
							onClick={() => handleLerTodas()}>
							Marcar todos como lido
						</ButtonStyled>

						<div style={{ backgroundColor: 'white', padding: '1%', fontWeight: 'bold' }}>
							<text>Central de Notificações</text>
						</div>

						<Table responsive>
							<tbody>
								{notificacoes.map((notificacao, index) => {

									return (
										<TrStyled
											key={index}
											style={{ color: notificacao.read ? `${color.grayDark}` : `${color.black}` }}
											onClick={() => handleRequestNotification(notificacao)}>

											{/* <td>
												<Form>
													<FormGroup
														check
														inline
													>
														<Input type="checkbox" checked={index === 4} onChange={() => console.log('test checked')} />
													</FormGroup>
												</Form>
											</td> */}
											<td>{notificacao.created_at}</td>
											<td>{notificacao.subject}</td>
											<td>{notificacao.message}</td>
										</TrStyled>
									)
								})}
							</tbody>
						</Table>
						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							<Pagination
								activePage={pagina}
								totalItemsCount={totalItems}
								onChange={(page) => handlerPagination(page)}
								prevPageText={<ChevronLeftOutlined />}
								nextPageText={<ChevronRightOutlined />}
								firstPageText={<FirstPageOutlined />}
								lastPageText={<LastPageOutlined />}
							/>
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}
